export default __webpack_public_path__ + "static/media/logout.cfefb56b.svg";